/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {getSectionElementId, useElementIsAbove, useIsSectionComplete} from "../../../Hooks/SurveyFormNavigationHooks";
import {Col} from "react-bootstrap";
import {StreamBankAnchorLink} from "../StreamBankAnchorLink";
import {Glyphicon} from "../GlyphIcon";
import React from "react";

export const SurveyNavigationItem = (props) => {
    const {
        section
    } = props;
    
    const sectionId = getSectionElementId(section);
    
    const isSectionHeaderPassed = useElementIsAbove(sectionId, -50);
    
    if (!section.name) {
        return null;
    }
    
    const anchor = getSectionElementId(section);
    const activeClass = isSectionHeaderPassed
        ? "sb-survey-form-navigation-passed" : "sb-survey-form-navigation-future";
    const sectionComplete = section?.isSectionComplete ?? false
    
    let classes = "sb-survey-form-navigation-control-record " + activeClass;
    
    if (sectionComplete) {
        classes += " sb-survey-form-navigation-control-record-completed";
    }
    
    return (
        <Col key={section.surveySectionId} className={classes} xs={12}>
            <StreamBankAnchorLink anchor={anchor}>
                <span>{section.name}</span>
                {
                    sectionComplete ?
                        <Glyphicon glyph="check-circle" className="ml-2"/> :
                        null
                }
            </StreamBankAnchorLink>
        </Col>
    );
}
